import Apptimize from '@apptimize/apptimize-web-sdk'

import featureFlags from 'const/featureFlags'
import loadDynamicYieldScript from 'helpers/loadDynamicYieldScript'

const updateFeatureFlags = (
  setIsFeatureFlagsFetched: (flag: boolean) => void,
  isApptimizeInitialized: boolean
) => {
  // localFeatureFlags are used in development and test modes.
  if (process.env.NODE_ENV === 'production' && isApptimizeInitialized) {
    // update featureflags in config file with apptimize when apptimize is initialized
    Object.keys(featureFlags).forEach((flag: string) => {
      featureFlags[flag] = Apptimize.isFeatureFlagEnabled(flag)
    })
  }
  setIsFeatureFlagsFetched(true)
  loadDynamicYieldScript()
}

export default updateFeatureFlags
